/**
 * All types of elements that were available with former decorativeElement prop, so they are available for V2 as well.
 */
export var ProductCardDecorativeElementTypeEnum;
(function (ProductCardDecorativeElementTypeEnum) {
    ProductCardDecorativeElementTypeEnum["ICON"] = "ICON";
    ProductCardDecorativeElementTypeEnum["ICON_HIGHLIGHTED"] = "ICON_HIGHLIGHTED";
    ProductCardDecorativeElementTypeEnum["ILLUSTRATION"] = "ILLUSTRATION";
    ProductCardDecorativeElementTypeEnum["IMAGE"] = "IMAGE";
    ProductCardDecorativeElementTypeEnum["AVATAR_PROFILE"] = "AVATAR_PROFILE";
})(ProductCardDecorativeElementTypeEnum || (ProductCardDecorativeElementTypeEnum = {}));
//# sourceMappingURL=decorativeElement.js.map